module.exports = __webpack_public_path__ + "img/img36_2.61ba3d2f.svg";